var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.207,
    height: 17,
    viewBox: "0 0 19.207 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7066",
    "data-name": "Group 7066",
    transform: "translate(-69.5 -560.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7479",
    "data-name": "Path 7479",
    d: "M92,425v-2a2,2,0,0,0-2-2H83a2,2,0,0,0-2,2v12a2,2,0,0,0,2,2h7a2,2,0,0,0,2-2v-2",
    transform: "translate(-11 140)",
    fill: "none",
    stroke: "#0A1E5B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7480",
    "data-name": "Path 7480",
    d: "M87,429H99l-3-3",
    transform: "translate(-11 140)",
    fill: "none",
    stroke: "#0A1E5B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7481",
    "data-name": "Path 7481",
    d: "M96,432l3-3",
    transform: "translate(-11 140)",
    fill: "none",
    stroke: "#0A1E5B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutMenu);
export default __webpack_public_path__ + "static/media/logout-menu.45139650a7e271071a0a389576b6afe7.svg";
export { ForwardRef as ReactComponent };